import { isEnabled } from "lib/@components/feature"
import { FEATURE_FLAG_TAILORED_SCHEDULE_AUDITING } from "../server/feature-flag-tailored-schedule-auditing.mjs"

export function isTailoredScheduleAuditingEnabled() {
    return isEnabled(FEATURE_FLAG_TAILORED_SCHEDULE_AUDITING)
}
